import SideMenu from '@/containers/side-menu/SideMenu.vue';
import Labels from '@/pages/labels/Labels.vue';

export default {
  path: '/labels',
  name: 'Labels',
  components: {
    mainContent: Labels,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'labels',
    },
    breadcrumb: {
      title: 'Labels',
      paths: [{ title: 'Cadastro' }, { title: 'Labels' }],
    },
  },
};
